<template>
  <div>
    <!--
    <div class="row">
      <div class="col-12 col-md-6">
      
      </div>
      
    </div>-->
    
    <div class="container" id="main">
      <div class="row justify-content-center">
        <div id="logohead" class="col-12 col-lg-8">
          <img :src="logo" />
        </div>
      </div>
      <div v-if="errortext != null" class="row justify-content-center">
        <div id="globalerror" class="col-12 col-lg-8">
          <div
            class="alert alert-danger"
            role="alert"
            style="margin-bottom:20px"
          >{{displayErrorText}}</div>
        </div>
      </div>
      <div class="row justify-content-center">
        <div
          id="content"
          class="col-12 col-lg-8"
          v-bind:style="{ backgroundColor: Company.CI_Contentbgcolor, border: '1px solid ' + Company.CI_Contentbordercolor }"
        >
          <LoginDefault
            v-if="$route.path == '/login' || ($route.path == '/read' && Session == null) || ($route.path == '/read' && Session != null && !Session.IsLoggedIn)"
          />
          <ReadEsprit v-if="$route.path == '/read' && Session != null && Session.IsLoggedIn" />
          <RegisterEsprit v-if="$route.path == '/register' && Company != null" />
          <ResetPasswordDefault v-if="$route.path == '/passwordchange' && Company != null && RequestCode != null" />
        </div>
      </div>
    </div>

    <!--<div id="content" v-bind:style="{ backgroundColor: CI_Contentbgcolor, border: '1px solid ' + CI_Contentbordercolor }">-->

    <!--<LoginDefault v-if="$route.path == '/login'" />   fixed-bottom-->
    <BottomNav />
  </div>
</template>

<script>
import LoginDefault from "../components/LoginDefault";
import ReadEsprit from "../components/ReadEsprit";
import RegisterEsprit from "../components/RegisterEsprit";
import BottomNav from "../components/BottomNav";
import ResetPasswordDefault from "../components/ResetPasswordDefault"

export default {
  name: "EspritTemplate",
  components: {
    LoginDefault,
    BottomNav,
    ReadEsprit,
    RegisterEsprit,
    ResetPasswordDefault
  },
  data: function() {
    return {
      errortext: null
    };
  },
  mounted: function() {},
  computed: {
    logo: function() {
      if (this.Company != null) {
        return (
          window.location.protocol +
          "//" +
          window.location.host +
          "/logos/logo_" +
          this.Company.Logo
        );
      } else {
        return "";
      }
    },
    displayErrorText: function() {
      return this.LanguageStrings[this.DisplayLanguage][this.errortext];
    }
  },
  methods: {}
};
</script>

<style scoped>
@media screen {
  /*table {
    border-collapse: collapse;
    border-spacing: 0;
  }*/

  #main {
    margin-top: 40px;
  }

  #logohead {
    padding: 0px;
    margin-bottom: 20px;
  }

  #globalerror {
    padding: 0px;
    margin-bottom: 0px;
  }

  #footer {
    padding: 0px;
    margin-top: 10px;
  }

  #content {
    margin-bottom: 100px;
    padding: 20px;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 576px) {
    #content {
      margin-left: 5%;
      margin-right: 5%;
      max-width: 90% !important;
    }
  }
  @media (max-width: 900px) {
    #logohead img {
      max-width: 95%;
    }
  }
  @media (max-width: 576px) {
    #logohead img {
      max-width: 90%;
      margin-left: 5%;
      margin-right: 5%;
    }
  }

  h1 {
    font-size: 20px;
    margin-bottom: 30px;
  }

  h2 {
    font-size: 15px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  /*
  ul {
    margin-left: 20px;
  }
  p {
    margin-top: 5px;
    margin-bottom: 5px;
  }
  td {
    padding-bottom: 7px;
  }
  li {
    margin-bottom: 7px;
  }
  li a {
    text-decoration: none;
    font-weight: bold;
  }

  .tablekey {
    font-weight: bold;
  }

  hr {
    display: block;
    height: 1px;
    border: 0;
    margin: 1em 0;
    padding: 0;
    margin-top: 20px;
  }
  .tablevalue {
    padding-left: 10px;
  }*/
}
</style>
